import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSite } from '../../context/SiteContext';
import { applySeo, resolveSeoForLocation } from '../../utils/seo';

/**
 * Route-aware SEO head manager for indexing + Google Ads landing quality.
 * Keeps titles/descriptions/canonicals/robots in sync with the URL.
 */
const DocumentHead = () => {
  const { pathname, search } = useLocation();
  const site = useSite();

  useEffect(() => {
    const seo = resolveSeoForLocation(pathname, search, {
      siteName: site.siteName,
      tagline: site.tagline,
    });
    applySeo(seo);
  }, [pathname, search, site.siteName, site.tagline]);

  return null;
};

export default DocumentHead;
